import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, InfinityIcon, ClockIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 md:py-32 px-4" style={{
    backgroundColor: '#e76f51'
  }} data-id="element-106">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto rounded-3xl p-8 md:p-16 text-center bg-white shadow-2xl" data-id="element-107">
        <img src="https://cdn.magicpatterns.com/uploads/dfYW75Hxz71ncDbXzj4i9n/Diseno_sin_titulo_(6).png" alt="Garantía 30 días incondicional" loading="lazy" decoding="async" className="w-24 h-24 md:w-32 md:h-32 mx-auto mb-6 md:mb-8 object-contain" data-id="element-108" />

        <h2 className="text-3xl md:text-5xl font-bold mb-6 md:mb-8" style={{
        color: '#1A1614'
      }} data-id="element-109">
          Garantía
        </h2>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 mb-8 md:mb-10" data-id="element-110">
          {[{
          icon: DownloadIcon,
          text: 'Descarga inmediata'
        }, {
          icon: InfinityIcon,
          text: 'Acceso de por vida'
        }, {
          icon: ClockIcon,
          text: '30 días de garantía'
        }].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-111">
              <item.icon className="w-5 h-5" style={{
            color: '#e76f51'
          }} data-id="element-112" />
              <span className="text-sm md:text-base font-bold" style={{
            color: '#1A1614'
          }} data-id="element-113">
                {item.text}
              </span>
            </div>)}
        </div>

        <div className="space-y-2 md:space-y-4" data-id="element-114">
          <p className="text-lg md:text-xl" style={{
          color: '#5a5248'
        }} data-id="element-115">
            El riesgo no es intentarlo.
          </p>
          <p className="text-xl md:text-2xl font-bold" style={{
          color: '#e76f51'
        }} data-id="element-116">
            El riesgo es quedarte en lo común.
          </p>
        </div>
      </motion.div>
    </section>;
}